import { InspectorProps } from "@app/components/WidgetStudio/Inspector/contracts/InspectorProps";
import {PlatformType} from "@app/types/platform"
import {
  Button,
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  Tooltip,
  Separator,
} from "@shortsworks/ui";
import { cn } from "@shortsworks/ui/lib/utils";
import {useGetProductList, useGetAccountPlatform} from "@shortsworks/user-api"
import { LoaderCircle, Info } from "lucide-react";
import { Children, useState, useEffect } from "react";

export interface PostingInspectorProps extends InspectorProps {}
export const ProductsInspector = ({
  defaultFormValues,
  onValueChange,
}: PostingInspectorProps) => {
  // 플랫폼 정보에 따라서 상품을 받아오는 양식이 달라짐
  const {data: accountPlatform, isSuccess: isSuccessGetAccountPlatform} = useGetAccountPlatform();

  const { data: productListData, isSuccess: isSuccessGetProductList } =
    useGetProductList({ name: "" });

  const [selectedProductIds, setSelectedProductIds] = useState<string[]>(
    defaultFormValues.productId ?? [],
  );

  const handleClickResetSelectId = () => {
    return setSelectedProductIds([]);
  };

  const handleErrorImageLoadFailed = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const imageElement = event.target as HTMLImageElement;
    return imageElement.style.visibility = "hidden";
  }

  const handleClickSelectId = (selectedId: string) => () => {
    if (selectedProductIds.includes(selectedId)) {
      return setSelectedProductIds((prevState) =>
        prevState.filter((productId) => productId !== selectedId),
      );
    } else {
      return setSelectedProductIds((prevState) => [...prevState, selectedId]);
    }
  };

  useEffect(() => {
    return onValueChange({ productId: selectedProductIds });
  }, [selectedProductIds]);

  if (!isSuccessGetProductList || !isSuccessGetAccountPlatform) {
    return <LoaderCircle className="w-full h-6 mr-2 animate-spin" />;
  }

  const platformType = accountPlatform.data.platformType;
  if(platformType === PlatformType.SHORTSWORKS) {
    return (
        <div className="flex flex-col gap-4 items-center p-4">
          <div className="text-center text-md">현재 독립 쇼핑몰은 상품을 불러오는 기능이 제공되지 않습니다.</div>
          <div className="underline text-primary text-sm">문의하기</div>
        </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row gap-2 text-xs text-blue-400">
        <Info height={18} width={18} />
        <div>
          자동 모드에서는 상품 페이지가 아닌 경우, 위젯이 표시되지 않습니다.
        </div>
      </div>
      <div className="flex flex-row gap-1">
        <Button className="w-full" sele variant="ghost">
          수동
        </Button>
        <Button className="w-full" variant="ghost">
          자동
        </Button>
      </div>

      <Separator />
      <div>상품 목록</div>
      <Button onClick={handleClickResetSelectId} variant="outline">
        전체
      </Button>
      {Children.toArray(
        productListData.data?.products.map((product) => {
          const isSelectedId = selectedProductIds.includes(product.id);
          return (
            <div
              className={cn(
                "flex flex-row gap-2 h-fit items-start select-none",
                isSelectedId && "font-bold bg-primary-foreground",
              )}
              onClick={handleClickSelectId(product.id)}
            >
              {/* @ts-ignore : params 변경 필요 */}
              <img onError={handleErrorImageLoadFailed} className="w-12 h-12" alt="" src={product.thumbnail ?? ""} />
              <div>
                <div>{product.name}</div>
              </div>
            </div>
          );
        }),
      )}
    </div>
  );
};
